var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPiggyBank(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29 26H14.9m7.1 7V18.9m-8.1 23.3c0 7.4 3.5 14.1 9 18.9 1.4 1.2 2.1 2.9 2.1 4.7V68c0 1.9 1.5 3.4 3.4 3.4h7.1c1.9 0 3.4-1.5 3.4-3.4v-1.5H46V68c0 1.9 1.5 3.4 3.4 3.4h7.1c1.9 0 3.4-1.5 3.4-3.4v-2.1c0-1.8.7-3.5 2.1-4.7 4-3.4 7-7.9 8.3-12.9h1.6c1.9 0 3.4-1.5 3.4-3.4v-6.1c0-1.9-1.5-3.4-3.4-3.4h-1.8c-1.3-4.4-3.8-8.3-7.3-11.4-.6-.5-.9-1.2-.9-2 0-3 1.1-6.3 1.6-7.8.1-.4-.1-.9-.6-1-2.3-.5-6.6 1.8-9.7 3.8-.7.5-1.5.6-2.3.3-2.7-.7-5.5-1.2-8.4-1.2M40 26c0 9.941-8.059 18-18 18S4 35.941 4 26 12.059 8 22 8s18 8.059 18 18zm20.6 7.6a2.1 2.1 0 11-4.2 0 2.1 2.1 0 014.2 0z",
    stroke: "#FF5800",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPiggyBank);
export default __webpack_public_path__ + "static/media/piggy-bank.b9c019aae4a8f12dff7fd14b4d0c0b60.svg";
export { ForwardRef as ReactComponent };